/**
 *  DropDown script file
**/

import { clickOutside } from '@/directives/click-outside'

export default {
  name: 'app-dropDown',
  mixins: [],
  components: {},
  directives: {
    clickOutside
  },
  props: {
    data: {
      type: Array,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    trigger: {
      type: Boolean,
      default: true,
      required: false
    },
    selected: {
      type: String,
      required: false
    },
    expanded: {
      type: Boolean,
      required: false
    },
    height: {
      type: String,
      default: 'auto',
      required: false
    },
    clickOutside: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      open: false,
      selectedId: null
    }
  },
  mounted () {
    this.selectedId = this.selected
    this.open = !!this.expanded
  },
  computed: {
  },
  methods: {
    hasSlot (name) {
      return !!this.$slots[name] || !!this.$scopedSlots[name]
    },
    toggle () {
      if (this.trigger !== false) {
        this.open = !this.open
        this.$emit('toggle')
      }
    },
    tryClose () {
      if (this.clickOutside) {
        this.close()
      }
    },
    close () {
      this.open = false
      this.$emit('toggle')
    },
    onItemClick (item) {
      this.selectedId = item.id
      this.open = false
      this.$emit('select', item)
    },
    enter (element) {
      element.style.height = 'auto'
      const height = getComputedStyle(element).height
      element.style.height = 0
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => {
        element.style.height = this.height === 'auto' ? height : this.height
      })
    },
    afterEnter (element) {
      element.style.height = this.height
    },
    leave (element) {
      const height = getComputedStyle(element).height
      element.style.height = height
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = 0 })
    }
  },
  watch: {
    open (value) {
      this.open = value || false
    }
  }
}
